__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__ttz86G__accordion",
});
